import { render, staticRenderFns } from "./BannerIndicadores.vue?vue&type=template&id=7ad53193"
import script from "./BannerIndicadores.vue?vue&type=script&lang=js"
export * from "./BannerIndicadores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports